module.exports = __webpack_public_path__ + "static/img/user-pick-propmotion-banner-matchup.c2cee87.png";